import styled, { css } from 'styled-components'
import { AnyObject, media } from '@rst/libs-ts'

export const maxWidthCotnainer = ({ theme }: AnyObject) =>
	theme?.containerMaxWidth
		? `min(${theme?.containerMaxWidth}px, calc(100% - ${
				(theme.minPadding || 0) * 2
		  }px))`
		: '1060px'

export const containerCss = css`
	width: 100%;
	margin: 0 auto;
	${media.pure.greater(1128)} {
		max-width: ${maxWidthCotnainer};
	}
	${media.pure.between(media.size.xs, 1128)} {
		padding-left: 34px;
		padding-right: 34px;
	}
	${media.pure.less(media.size.xs)} {
		padding-left: 18px;
		padding-right: 18px;
	}
`

export const Container = styled.div`
	${containerCss}
`
